import { PATCH, POST } from "../../APiHelper/API";

export const addLeagueToSeasonAPI = (season_id, competition_id, onSuccess, onError) => {
    const data = {
        competition_id: competition_id
    }
    PATCH(`/api/v1/leagues/seasons/${season_id}/add_competition`, data, onSuccess, onError)
}